var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { GetNotifications } from '../../api/Notifications';
import { METER_REPLACEMENT_NOTIFICATION, RTU_METER_REPLACEMENT_NOTIFICATION } from '../../constants/notificationTypes';
// ACTIONS TYPES
export const NOTIFICATION_SUCCESS = 'customer-portal/notifications/NOTIFICATION_SUCCESS';
export const NOTIFICATION_FAILURE = 'customer-portal/notifications/NOTIFICATION_FAILURE';
export const FETCHING_NOTIFICATIONS_LIST = 'customer-portal/notifications/FETCHING_NOTIFICATIONS_LIST';
export const RESET_NOTIFICATIONS = 'customer-portal/notifications/RESET_NOTIFICATIONS';
// ACTION CREATORS
const notificationSuccess = (notifications) => ({
    type: NOTIFICATION_SUCCESS,
    payload: notifications,
});
const notificationFailure = (err) => ({
    type: NOTIFICATION_FAILURE,
    payload: err,
});
const fetchingNotificationsList = () => ({
    type: FETCHING_NOTIFICATIONS_LIST,
});
export const resetNotifications = () => ({
    type: RESET_NOTIFICATIONS,
});
// THUNKS
export const fetchNotificationsList = (prospectId) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(fetchingNotificationsList());
    try {
        const { data } = yield GetNotifications(prospectId);
        dispatch(notificationSuccess(data));
    }
    catch (error) {
        dispatch(notificationFailure(error.message));
    }
});
export const shouldFetchNotifications = (notificationsState) => {
    if (notificationsState.get('loading') || notificationsState.get('loaded')) {
        return false;
    }
    return true;
};
export const fetchNotificationsIfNeeded = (prospectId) => (dispatch, getState) => {
    if (!shouldFetchNotifications(getState().notifications)) {
        return null;
    }
    return dispatch(fetchNotificationsList(prospectId));
};
// SELECTORS
const notificationsSelector = (state) => state.notifications;
export const getNotifications = createSelector([notificationsSelector], notifications => notifications.get('notifications'));
export const getNotificationsLoading = createSelector([notificationsSelector], notifications => notifications.get('loading') || !notifications.get('loaded'));
export const getIsMeterReplacementCustomer = createSelector([notificationsSelector], notifications => {
    const notifs = notifications.get('notifications');
    return notifs.includes(METER_REPLACEMENT_NOTIFICATION) || notifs.includes(RTU_METER_REPLACEMENT_NOTIFICATION);
});
const initialStateObj = {
    loaded: false,
    loading: false,
    error: null,
    notifications: [],
};
// REDUCER
export const initialState = fromJS(initialStateObj);
export default (state = initialState, action) => {
    switch (action.type) {
        case NOTIFICATION_SUCCESS:
            // @ts-ignore - state is very broad Map type when derived via `fromJs`, setting its keys to a boolean is okay
            return state.set('loaded', true).set('loading', false).set('error', null).set('notifications', action.payload);
        case NOTIFICATION_FAILURE:
            // @ts-ignore - state is an immutable map when derived via `fromJs`
            return state.set('loading', false).set('loaded', true).set('error', action.payload);
        case FETCHING_NOTIFICATIONS_LIST:
            // @ts-ignore - state is an immutable map when derived via `fromJs`
            return state.set('loading', true);
        case RESET_NOTIFICATIONS:
            return initialState;
        default:
            return state;
    }
};
